import { j as a } from "../../../jsx-runtime-ClSzPYp4.js";
import r from "../Loadable.mjs";
const l = (o) => /* @__PURE__ */ a.jsx(r, {
  logoProps: {
    primaryColor: "capitalOne.red500",
    secondaryColor: "capitalOne.blue750"
  },
  ...o
});
export {
  l as default
};
